export const getLocalStorageItem = (key: string, defaultValue: any = null) => {
  try {
    const value = localStorage.getItem(key);
    if (!value) return defaultValue;
    return JSON.parse(value);
  } catch {
    return defaultValue;
  }
};

/** Returns false when the write was rejected -- quota, private mode, storage disabled. */
export const setLocalStorageItem = (key: string, value: any): boolean => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
};
